/**
 * The payload URL, resolved against the app's public base.
 *
 * Both the page and the worker need it, and the worker cannot compute it: a
 * worker's relative URLs resolve against its own bundled chunk location, not
 * against the page.
 *
 * Create React App exposes the deployment base as `process.env.PUBLIC_URL`,
 * which webpack inlines at build time (empty string when hosted at the domain
 * root, `/sub/path` otherwise). That keeps the app working under a sub-path and
 * on GitHub Pages-style hosting without hardcoding anything.
 */
export function surfaceDataUrl(): string {
  const base = process.env.PUBLIC_URL ?? "";
  return `${base}/data/surface.json`;
}
